import React from 'react'
import HeroSection from '../Components/home/HeroSection'
import TechServicesSection from '../Components/home/TechServicesSection'
import LatestInsightsSection from '../Components/home/LatestInsightsSection'
import ClientsCareersSection from '../Components/home/ClientsCareersSection'
import { Helmet } from 'react-helmet-async';
import { motion } from "framer-motion";
import { ChevronRight, Link } from 'lucide-react'
import ContactSection from '../Components/home/ContactSection'
import ContactSection2 from '../Components/home/ContactSection2'

function Home3() {
    return (
        <div>
            <Helmet>
                <title>
                    Mobikode | Enterprise AI & ServiceNow Consulting Company
                </title>

                <meta
                    name="description"
                    content="Mobikode is an Enterprise AI and ServiceNow consulting company helping businesses modernize operations with AI automation, ServiceNow solutions, cloud engineering, enterprise applications, data analytics, and Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    name="keywords"
                    content="Enterprise AI Consulting Company, AI Consulting Services, ServiceNow Consulting Company, ServiceNow Consulting Services, ServiceNow Implementation Services, ServiceNow Development Services, AI Automation Services, Enterprise AI Solutions, Enterprise AI & ServiceNow Consulting Services, ServiceNow Partner, ServiceNow Solutions, AI Technology Solutions, Cloud Engineering Services, Enterprise Application Services, Data Analytics Services, Mobikode"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/"
                />

                <meta
                    property="og:title"
                    content="Mobikode | Enterprise AI & ServiceNow Consulting Company"
                />

                <meta
                    property="og:description"
                    content="Mobikode delivers Enterprise AI and ServiceNow consulting solutions to help businesses automate operations, modernize workflows, improve efficiency, and accelerate Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/home-/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Mobikode | Enterprise AI & ServiceNow Consulting Company"
                />

                <meta
                    name="twitter:description"
                    content="Explore Mobikode's Enterprise AI and ServiceNow consulting services, including AI automation, ServiceNow implementation, cloud engineering, enterprise applications, analytics, and Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/home-/bg1.png"
                />
            </Helmet>
            <HeroSection />
            <section className="w-full bg-[#EDEDED] py-[16px] lg:py-[22px]">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-10">

                        <div className="shrink-0 text-center lg:text-left">
                            <h2 className="font-sora text-[22px] sm:text-[26px] lg:text-[28px] font-[600] text-[#01386A] tracking-tight whitespace-nowrap">
                                Partner Ecosystem
                            </h2>
                        </div>

                        <div className="grid grid-cols-2 md:grid-cols-4 items-center w-full">

                            <div className="relative flex items-center justify-center p-4 h-[110px] sm:h-[130px]">
                                <img
                                    src="/assets/home/snlogo.png"
                                    alt="ServiceNow Partner"
                                    className="max-w-[190px] sm:max-w-[210px] max-h-[70px] sm:max-h-[80px] w-auto h-auto object-contain"
                                />
                                <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 h-[65px] w-[2px] bg-[#FFFFFF]" />
                            </div>

                            <div className="relative flex items-center justify-center p-4 h-[110px] sm:h-[130px]">
                                <img
                                    src="/assets/home/p2.png"
                                    alt="Databricks Partner"
                                    className="max-w-[180px] sm:max-w-[200px] max-h-[70px] sm:max-h-[80px] w-auto h-auto object-contain"
                                />
                                <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 h-[65px] w-[2px] bg-[#FFFFFF]" />
                            </div>

                            <div className="relative flex items-center justify-center p-4 h-[110px] sm:h-[130px]">
                                <img
                                    src="/assets/home/p3.png"
                                    alt="dbt Labs"
                                    className="max-w-[180px] sm:max-w-[200px] max-h-[70px] sm:max-h-[80px] w-auto h-auto object-contain"
                                />
                                <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 h-[65px] w-[2px] bg-[#FFFFFF]" />
                            </div>

                            <div className="relative flex items-center justify-center p-4 h-[110px] sm:h-[130px]">
                                <img
                                    src="/assets/home/p1.png"
                                    alt="Claude Partner Network"
                                    className="max-w-[190px] sm:max-w-[210px] max-h-[70px] sm:max-h-[80px] w-auto h-auto object-contain"
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </section>
            <TechServicesSection />
            <ClientsCareersSection />
            <LatestInsightsSection />

            <ContactSection />
            {/* <ContactSection2 /> */}
            {/* <section className='lg:pb-[80px] pb-[50px]'>
                <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px] relative z-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px] lg:gap-[30px]">
                        <TalentCard
                            title="We are always searching for the best talent"
                            linkText="View All Global Openings"
                            link="/careers"
                            bgImage="/assets/home-/img4.png"
                        />
                        <TalentCard
                            title="Let’s Discuss Your Business and Technology Needs"
                            linkText="Explore Services"
                            link="/what-we-do"
                            bgImage="/assets/home-/img5.jpg"
                        />
                    </div>
                </div>
            </section> */}
        </div>
    )
}

export default Home3



const TalentCard = ({ title, linkText, bgImage, link }) => {
    return (
        <motion.div
            initial="rest"
            whileHover="hover"
            animate="rest"
            variants={{
                rest: { y: 0, boxShadow: "0 10px 30px -15px rgba(0, 0, 0, 0.3)" },
                hover: { y: -8, boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)" }
            }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="group relative h-[320px] sm:h-[350px] lg:h-[400px] overflow-hidden cursor-pointer"
        >
            <div className="absolute inset-0 overflow-hidden">
                <motion.img
                    src={bgImage}
                    alt="Career Background"
                    variants={{
                        rest: { scale: 1 },
                        hover: { scale: 1.1 }
                    }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-[#01386A4D] z-0" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#01386A]/90 via-[#01386A]/20 to-transparent z-0" />
            </div>

            <div className="absolute bottom-0 left-0 w-full p-[24px] lg:p-[40px] z-10 flex flex-col justify-end h-full">
                <motion.h3
                    variants={{
                        rest: { y: 0 },
                        hover: { y: -5 }
                    }}
                    transition={{ duration: 0.4, ease: "easeOut" }}
                    className="text-white text-[16px] lg:text-[20px] font-[600] font-sora leading-[1.2] mb-4"
                >
                    {title}
                </motion.h3>

                <Link to={link || "#"} className="inline-block">
                    <div className="flex items-center gap-2 text-white font-[500] text-[14px] lg:text-[16px] font-graphik">
                        {linkText}
                        <ChevronRight size={18} className="group-hover:translate-x-2 transition-transform duration-300" />
                    </div>
                    <div className="h-[2px] bg-[#F28C28] mt-2 w-0 group-hover:w-full transition-all duration-300" />
                </Link>
            </div>
        </motion.div>
    );
};